// ======================================================================
// File Name       : FunctionAuthConstants
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import * as FUNCTION from './FunctionConstants';
import { READ, WRITE } from './index';

// 権限ロール管理権限
const AUTHORITY_MANAGEMENT_READ = [FUNCTION.AUTHORITY_LIST, FUNCTION.AUTHORITY_DETAIL];
const AUTHORITY_MANAGEMENT_WRITE = [
  ...AUTHORITY_MANAGEMENT_READ,
  FUNCTION.AUTHORITY_REGISTER,
  FUNCTION.AUTHORITY_EDIT,
  FUNCTION.AUTHORITY_IMPORT,
];

// お知らせ管理権限
const NOTICE_MANAGEMENT_READ = [
  FUNCTION.NOTIFICATION_LIST,
  FUNCTION.NOTIFICATION_DETAIL,
  FUNCTION.SERVICE_NOTIFICATION_LIST,
  FUNCTION.SERVICE_NOTIFICATION_DETAIL,
];
const NOTICE_MANAGEMENT_WRITE = [
  ...NOTICE_MANAGEMENT_READ,
  FUNCTION.NOTIFICATION_REGISTER,
  FUNCTION.NOTIFICATION_EDIT,
  FUNCTION.SERVICE_NOTIFICATION_REGISTER,
  FUNCTION.SERVICE_NOTIFICATION_EDIT,
  FUNCTION.SERVICE_NOTIFICATION_IMPORT,
];

// ユーザー管理権限
const USER_MANAGEMENT_READ = [FUNCTION.USER_LIST, FUNCTION.USER_DETAIL];
const USER_MANAGEMENT_WRITE = [
  ...USER_MANAGEMENT_READ,
  FUNCTION.USER_REGISTER,
  FUNCTION.USER_EDIT,
  FUNCTION.NOTIFICATION_EDIT,
  FUNCTION.USER_IMPORT,
];

// ユーザーグループ管理権限
const GROUP_MANAGEMENT_READ = [FUNCTION.GROUP_LIST, FUNCTION.GROUP_DETAIL];
const GROUP_MANAGEMENT_WRITE = [
  ...GROUP_MANAGEMENT_READ,
  FUNCTION.GROUP_REGISTER,
  FUNCTION.GROUP_EDIT,
  FUNCTION.GROUP_DELETE,
  FUNCTION.GROUP_IMPORT,
];

// ライブ管理
const LIVE_MANAGEMENT_READ = [];
const LIVE_MANAGEMENT_WRITE = [
  ...LIVE_MANAGEMENT_READ,
];

// 成績・実績管理権限
const ACHIVEMENT_MANAGEMENT_READ = [
  FUNCTION.ARCHIVEMENT_COURSE_LIST,
  FUNCTION.ARCHIVEMENT_STUDENT_LIST,
  FUNCTION.ARCHIVEMENT_CONTENT_USAGE_LIST,
];

// ユーザー履歴管理権限
const HISTORY_MANAGEMENT_READ = [
  FUNCTION.USER_HISTORY_STUDENT_LIST,
  FUNCTION.USER_HISTORY_STUDENT_DETAIL,
  FUNCTION.USER_HISTORY_STUDENT_RESULT,
  FUNCTION.USER_HISTORY_CONTENT_LIST,
  FUNCTION.USER_HISTORY_COURSE_LIST,
  FUNCTION.USER_HISTORY_CONTENT_DETAIL,
  FUNCTION.USER_HISTORY_COURSE_DETAIL,
  FUNCTION.USER_HISTORY_LIVE_PERFORMANCE_LIST,
  FUNCTION.USER_HISTORY_LIVE_PERFORMANCE_DETAIL,
  FUNCTION.PARTICIPANT_LIST,
  FUNCTION.USER_HISTORY_COURSE_STUDENT_DETAIL,
  FUNCTION.USER_HISTORY_COURSE_STUDENT_RESULT,
  FUNCTION.PARTICIPANT_DETAIL,
  FUNCTION.LEARNING_HISTORY_CSV_DOWNLOAD,
  FUNCTION.PROGRESS_STATUS_CSV_DOWNLOAD,
  FUNCTION.USER_HISTORY_AGGREGATE_BY_PROBLEM_DETAIL, // #7386
];
const HISTORY_MANAGEMENT_WRITE = [...HISTORY_MANAGEMENT_READ];

// 外部コンテンツ管理権限
const EXTERNAL_CONTENT_MANAGEMENT_READ = [
  FUNCTION.EXTERNAL_CONTENT_LIST,
  FUNCTION.EXTERNAL_CONTENT_OFFER_LIST,
];
/*
  外部コンテンツ管理の権限を指定する
  0：利用なし
  1：参照
  2：参照・登録・編集
*/

// コース管理権限
const COURSE_MANAGEMENT_READ = [
  FUNCTION.COURSE_LIST,
  FUNCTION.COURSE_DETAIL,

  FUNCTION.BOX_DETAIL,

  FUNCTION.CONTENT_LINKING_DETAIL,
];
const COURSE_MANAGEMENT_WRITE = [
  ...COURSE_MANAGEMENT_READ,
  FUNCTION.COURSE_REGISTER,
  FUNCTION.COURSE_EDIT,
  FUNCTION.COURSE_DELETE,
  FUNCTION.COURSE_IMPORT,
  FUNCTION.COURSE_THUMBNAIL_UPDATE,
  FUNCTION.COURSE_RESET_CONDITION,
  FUNCTION.COURSE_SORT,

  FUNCTION.BOX_REGSITER,
  FUNCTION.BOX_EDIT,
  FUNCTION.BOX_DELETE,
  FUNCTION.BOX_SORT,

  FUNCTION.CONTENT_LINKING_REGISTER,
  FUNCTION.CONTENT_LINKING_EDIT,
  FUNCTION.CONTENT_LINKING_DELETE,
  FUNCTION.CONTENT_LINKING_SORT,

];

// 多言語表示
const MULTI_LANGUAGE_MANAGEMENT_READ = [
  FUNCTION.MULTI_LANGUAGE_LIST,
  FUNCTION.MULTI_LANGUAGE_PROCESS_RESULT_LIST,
  FUNCTION.MULTI_LANGUAGE_EDIT,
  FUNCTION.MULTI_LANGUAGE_PROCESS_DETAIL,
];

const MULTI_LANGUAGE_MANAGEMENT_WRITE = [
  ...MULTI_LANGUAGE_MANAGEMENT_READ,
];

// コンテンツ管理権限
const CONTENT_MANAGEMENT_READ = [
  FUNCTION.CONTENT_LIST,
  FUNCTION.CONTENT_VIDEO_LIST,
  FUNCTION.CONTENT_LINK_LIST,
  FUNCTION.CONTENT_LINK_DETAIL,
  FUNCTION.CONTENT_LIVE_LIST,
  FUNCTION.CONTENT_LIVE_LIST,
  ...MULTI_LANGUAGE_MANAGEMENT_READ,
];

const CONTENT_MANAGEMENT_WRITE = [
  ...CONTENT_MANAGEMENT_READ,
  FUNCTION.PREVIEW_EACH_QUESTION_ATTRIBUTE,
  FUNCTION.CONTENT_QUESTION_PERSPECTIVE,
  FUNCTION.CONTENT_LINK_REGISTER,
  FUNCTION.CONTENT_LINK_EDIT,
  FUNCTION.CONTENT_LINK_IMPORT,
  ...MULTI_LANGUAGE_MANAGEMENT_WRITE,
];

const CONTENT_QUESTION_MANAGEMENT_READ = [
  FUNCTION.CONTENT_QUESTION_LIST,
  FUNCTION.CONTENT_QUESTION_DETAIL,
  FUNCTION.CONTENT_QUESTION_ATTRIBUTE_LIST,
];

const CONTENT_QUESTION_MANAGEMENT_WRITE = [
  ...CONTENT_QUESTION_MANAGEMENT_READ,
  FUNCTION.CONTENT_QUESTION_REGISTER,
  FUNCTION.CONTENT_QUESTION_EDIT,
  FUNCTION.CONTENT_QUESTION_IMPORT,
];

const CONTENT_DRILL_MANAGEMENT_READ = [
  ...CONTENT_QUESTION_MANAGEMENT_READ,
  FUNCTION.CONTENT_DRILL_LIST,
  FUNCTION.CONTENT_DRILL_DETAIL,
  FUNCTION.CONTENT_DRILL_MESSAGE,
  FUNCTION.CONTENT_DRILL_NOTIFICATION_LIST,
  FUNCTION.CONTENT_DRILL_SKIN_LIST,
  FUNCTION.CONTENT_DRILL_SKIN_DETAIL,
  FUNCTION.CONTENT_DRILL_NOTIFICATION_LIST,
  FUNCTION.CONTENT_DRILL_NOTIFICATION_DETAIL,
];

const CONTENT_DRILL_MANAGEMENT_WRITE = [
  ...CONTENT_DRILL_MANAGEMENT_READ,
  ...CONTENT_QUESTION_MANAGEMENT_WRITE,
  FUNCTION.CONTENT_DRILL_REGISTER,
  FUNCTION.CONTENT_DRILL_SKIN_REGISTER,
  FUNCTION.CONTENT_DRILL_SKIN_EDIT,
  FUNCTION.CONTENT_DRILL_CHARACTER,
  FUNCTION.CONTENT_DRILL_BUTTON_LABEL,
  FUNCTION.CONTENT_DRILL_NOTIFICATION_REGISTER,
  FUNCTION.CONTENT_DRILL_NOTIFICATION_EDIT,
  FUNCTION.CONTENT_DRILL_IMPORT,
  FUNCTION.CONTENT_DRILL_EDIT,
  FUNCTION.CONTENT_DRILL_MESSAGE,
];

const CONTENT_VIDEO_MANAGEMENT_READ = [
  FUNCTION.CONTENT_VIDEO_LIST,
  FUNCTION.CONTENT_VIDEO_DETAIL,
];

const CONTENT_VIDEO_MANAGEMENT_WRITE = [
  ...CONTENT_VIDEO_MANAGEMENT_READ,
  FUNCTION.CONTENT_VIDEO_REGISTER,
  FUNCTION.CONTENT_VIDEO_EDIT,
  FUNCTION.CONTENT_VIDEO_IMPORT,
];

const CONTENT_DOCUMENT_MANAGEMENT_READ = [
  FUNCTION.CONTENT_DOCUMENT_LIST,
  FUNCTION.CONTENT_DOCUMENT_DETAIL,
];

const CONTENT_DOCUMENT_MANAGEMENT_WRITE = [
  ...CONTENT_DOCUMENT_MANAGEMENT_READ,
  FUNCTION.CONTENT_DOCUMENT_REGISTER,
  FUNCTION.CONTENT_DOCUMENT_EDIT,
  FUNCTION.CONTENT_DOCUMENT_IMPORT,
];

// 採点管理権限
const SCORING_MANAGEMENT_READ = [
  FUNCTION.SCORING_REPORT_TOP,
  FUNCTION.SCORING_REPORT_LIST,
  FUNCTION.SCORING_REPORT_GET,
  FUNCTION.SCORING_REPORT_CORRECTION,
  FUNCTION.SCORING_REPORT_WITHDRAWAL,
];
const SCORING_MANAGEMENT_WRITE = [
  FUNCTION.SCORING_REPORT_LIST,
  FUNCTION.SCORING_REPORT_GET,
  FUNCTION.SCORING_REPORT_CORRECTION,
  
  FUNCTION.SCORING_REPORT_GET,
  FUNCTION.SCORING_REPORT_TOP,
  FUNCTION.SCORING_REPORT_APPROVAL,
  FUNCTION.SCORING_REPORT_REMAND,
  FUNCTION.SCORING_REPORT_COLLECTION,
  FUNCTION.SCORING_DISTRIBUTION_REPORT,

  FUNCTION.SCORING_RESULT_LIST,
  FUNCTION.SCORING_ARCHIVEMENT_LIST,
  FUNCTION.SCORING_ARCHIVEMENT_DETAIL,
  FUNCTION.SCORING_UNSUBMITTED_LIST,
];

// コンテンツ配布先管理権限
const DISTRIBUTION_CONTENT_MANAGEMENT_READ = [
  FUNCTION.CONTENT_DISTRIBUTION_LIST,
  FUNCTION.CONTENT_DISTRIBUTION_OFFER_LIST_DETAIL,
  FUNCTION.CONTENT_DISTRIBUTION_USAGE_DETAIL,
];
const DISTRIBUTION_CONTENT_MANAGEMENT_WRITE = [
  ...DISTRIBUTION_CONTENT_MANAGEMENT_READ,
  FUNCTION.CONTENT_DISTRIBUTION_REGISTER,
  FUNCTION.CONTENT_DISTRIBUTION_OFFER_LIST_EDIT,
  FUNCTION.CONTENT_DISTRIBUTION_EDIT,
  FUNCTION.CONTENT_DISTRIBUTION_IMPORT,
  FUNCTION.COURSE_DISTRIBUTION_IMPORT,
];

const REPORT_MANAGEMENT_READ = [
  FUNCTION.SCORING_REPORT_LIST,
];
const REPORT_MANAGEMENT_WRITE = [
  ...REPORT_MANAGEMENT_READ,
];

const SERVICE_RECORD_MANAGEMENT_READ = [
  FUNCTION.SERVICE_RECORD_SERVICE_LIST,
  FUNCTION.SERVICE_RECORD_SERVICES_LIST, // Step 12.3.0 TAS-21359
];

const SERVICE_RECORD_MANAGEMENT_WRITE = [
  ...SERVICE_RECORD_MANAGEMENT_READ,
  FUNCTION.SERVICE_RECORD_COMPANY_LIST,
  FUNCTION.SERVICE_RECORD_DOWNLOAD_FORM,
];

// メッセージ管理権限
const MESSAGE_THREAD_READ = [
  FUNCTION.RECEIVED_MESSAGE_LIST,
  FUNCTION.SENT_MESSAGE_LIST,
  FUNCTION.RECEIVE_MESSAGE_THREAD_DETAIL,
  FUNCTION.SENT_MESSAGE_THREAD_DETAIL,
  FUNCTION.SENT_CHAT_DETAIL,
  FUNCTION.RECEIVE_CHAT_DETAIL,
];

const MESSAGE_THREAD_WRITE = [
  ...MESSAGE_THREAD_READ,
  FUNCTION.REGISTER_MESSAGE_THREAD,
  FUNCTION.EDIT_MESSAGE_THREAD,
];

const ENTERPRISE_NOTICE_READ = [
  FUNCTION.ENTERPRISE_NOTIFICATION_LIST,
  FUNCTION.ENTERPRISE_NOTIFICATION_DETAIL,
];

const ENTERPRISE_NOTICE_WRITE = [
  ...ENTERPRISE_NOTICE_READ,
  FUNCTION.ENTERPRISE_NOTIFICATION_REGISTER,
  FUNCTION.ENTERPRISE_NOTIFICATION_EDIT,
  FUNCTION.ENTERPRISE_NOTIFICATION_IMPORT,
];

const ADAPTIVE_MANAGEMENT_READ = [
  FUNCTION.ADAPTIVE_META,
  FUNCTION.DISCRIMINATION_DEGREE_DATA,
];

const ADAPTIVE_MANAGEMENT_WRITE = [
  ...ADAPTIVE_MANAGEMENT_READ,
];

const CONFIG_FILE_READ = [
  FUNCTION.DOWNLOAD_CONFIG_FILE,
  FUNCTION.UPLOAD_CONFIG_FILE,
];

const CONFIG_FILE_WRITE = [
  ...CONFIG_FILE_READ,
];

// メール管理
const EMAIL_MANAGEMENT_READ = [
  FUNCTION.EMAIL_LIST,
  FUNCTION.RESERVED_EMAIL_LIST,
  FUNCTION.RESERVED_EMAIL_DETAIL,
];

const EMAIL_MANAGEMENT_WRITE = [
  ...EMAIL_MANAGEMENT_READ,
  FUNCTION.EMAIL_REGISTER,
  FUNCTION.RESERVED_EMAIL_EDIT,
];

// 受講者画面管理画面
const USERFRONT_MANAGEMENT_READ = [
  FUNCTION.USERFRONT_LOGIN_SCREEN_UPDATE,
  FUNCTION.USERFRONT_TOP_SCREEN_UPDATE,
];

const USERFRONT_MANAGEMENT_WRITE = [
  ...USERFRONT_MANAGEMENT_READ,
];

// ダウンロード資材管理権限
const MATERIAL_MANAGEMENT_READ = [
  FUNCTION.MATERIAL_DOWNLOAD,
];

const FUNCTION_AUTHORITY = {
  authorityManagementAuthority: {
    [READ]: AUTHORITY_MANAGEMENT_READ,
    [WRITE]: AUTHORITY_MANAGEMENT_WRITE,
  },
  noticeManagementAuthority: {
    [READ]: NOTICE_MANAGEMENT_READ,
    [WRITE]: NOTICE_MANAGEMENT_WRITE,
  },
  liveManagementAuthority: {
    [READ]: LIVE_MANAGEMENT_READ,
    [WRITE]: LIVE_MANAGEMENT_WRITE,
  },
  messageManagementAuthority: {
    [READ]: MESSAGE_THREAD_READ,
    [WRITE]: MESSAGE_THREAD_WRITE,
  },
  userManagementAuthority: {
    [READ]: USER_MANAGEMENT_READ,
    [WRITE]: USER_MANAGEMENT_WRITE,
  },
  groupManagementAuthority: {
    [READ]: GROUP_MANAGEMENT_READ,
    [WRITE]: GROUP_MANAGEMENT_WRITE,
  },
  achievementManagementAuthority: {
    [READ]: HISTORY_MANAGEMENT_READ,
    [WRITE]: HISTORY_MANAGEMENT_WRITE,
  },
  externalContentManagementAuthority: {
    [READ]: EXTERNAL_CONTENT_MANAGEMENT_READ,
  },
  courseManagementAuthority: {
    [READ]: COURSE_MANAGEMENT_READ,
    [WRITE]: COURSE_MANAGEMENT_WRITE,
  },
  contentManagementAuthority: {
    [READ]: CONTENT_MANAGEMENT_READ,
    [WRITE]: CONTENT_MANAGEMENT_WRITE,
  },
  scoringManagementAuthority: {
    [READ]: SCORING_MANAGEMENT_READ,
    [WRITE]: SCORING_MANAGEMENT_WRITE,
  },
  distributionContentManagementAuthority: {
    [READ]: DISTRIBUTION_CONTENT_MANAGEMENT_READ,
    [WRITE]: DISTRIBUTION_CONTENT_MANAGEMENT_WRITE,
  },
  reportManagementAuthority: {
    [READ]: REPORT_MANAGEMENT_READ,
    [WRITE]: REPORT_MANAGEMENT_WRITE,
  },
  performanceManagementAuthority: {
    [READ]: SERVICE_RECORD_MANAGEMENT_READ,
    [WRITE]: SERVICE_RECORD_MANAGEMENT_WRITE,
  },
  usageSettingDocument: {
    [READ]: CONTENT_DOCUMENT_MANAGEMENT_READ,
    [WRITE]: CONTENT_DOCUMENT_MANAGEMENT_WRITE,
  },
  usageSettingDrill: {
    [READ]: CONTENT_DRILL_MANAGEMENT_READ,
    [WRITE]: CONTENT_DRILL_MANAGEMENT_WRITE,
  },
  usageSettingVideo: {
    [READ]: CONTENT_VIDEO_MANAGEMENT_READ,
    [WRITE]: CONTENT_VIDEO_MANAGEMENT_WRITE,
  },
  enterpriseNoticeAuthority: {
    [READ]: ENTERPRISE_NOTICE_READ,
    [WRITE]: ENTERPRISE_NOTICE_WRITE,
  },
  adaptiveManagement: {
    [READ]: ADAPTIVE_MANAGEMENT_READ,
    [WRITE]: ADAPTIVE_MANAGEMENT_WRITE,
  },
  configFileManagement: {
    [READ]: CONFIG_FILE_READ,
    [WRITE]: CONFIG_FILE_WRITE,
  },
  emailManagementAuthority: {
    [READ]: EMAIL_MANAGEMENT_READ,
    [WRITE]: EMAIL_MANAGEMENT_WRITE,
  },
  userfrontManagementAuthority: {
    [READ]: USERFRONT_MANAGEMENT_READ,
    [WRITE]: USERFRONT_MANAGEMENT_WRITE,
  },
  materialManagementAuthority: {
    [READ]: MATERIAL_MANAGEMENT_READ,
  },
};

export const usageSettingAuthConstants = {
  liveManagementAuthorityMap: 'usageSettingLive',
};

export const contentMultiLanguageManagement = {
  contentMultiLanguageManagementAuthorityMap: MULTI_LANGUAGE_MANAGEMENT_READ,
};

export default FUNCTION_AUTHORITY;
